import FormGroupId from '@core/constants/FormGroupId';
import IFormGroups from '@core/interfaces/IFormGroups';
import { PublishedFormIdUnion } from '@furnish-hx/constants/FormId';
import { IForms } from '../../../interfaces/Form';

const getAvailableForms = (
    forms: IForms,
    formGroups: IFormGroups,
    formId: PublishedFormIdUnion | undefined,
    formGroupId: FormGroupId | undefined,
): IForms => {
    if (!formGroupId) return formId ? forms.filter((form) => form.formId === formId) : forms;

    return forms.reduce((acc, cur) => {
        if (cur.formId === formId) return [cur, ...acc];

        if (formGroups[formGroupId]?.includes(cur.formId as PublishedFormIdUnion)) return [...acc, cur];

        return acc;
    }, [] as IForms);
};

export default getAvailableForms;
